<template>
  <div>


    <section id="knowledge-base-content" :style="{
      backgroundImage: `url(${require('@/assets/images/banner/banner.png')})`,
    }" class="knowledge-base-bg text-center admin-menu" no-body>
      <!-- content -->
      <b-row class="kb-search-content-info match-height">
        <b-col v-for="item in listMenu" :key="item.url" class="kb-search-content" md="3" sm="4">
          <b-card :img-src="imgUrl" class="text-center cursor-pointer" img-top @click="() => onMoveTopic(item)">
            <h4>{{ item.Name }}</h4>
            <!-- <b-card-text class="mt-1">
              {{ item.Name }}
            </b-card-text> -->
          </b-card>
        </b-col>
      </b-row>
    </section>
  </div>
</template>

<script>
import {
  BCard,
  BCardBody,
  BCardText,
  BCol,
  BForm,
  BFormInput,
  BInputGroup,
  BInputGroupPrepend,
  BRow,
} from "bootstrap-vue";
import router from "@/router";

const imgUrl = require("@/assets/images/illustration/marketing.svg");
export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BCardText,
    BForm,
    BInputGroup,
    BInputGroupPrepend,
    BFormInput,
  },

  data() {
    return {
      listMenu: [],
      imgUrl: imgUrl,
    };
  },
  computed: {},
  created() {
    this.mockData();
  },

  methods: {
    mockData() {
      this.listMenu = [{Name: 'Quản trị danh mục', url: 'congtt-admin-danh-muc'}, {
        Name: 'Quản trị phòng ban',
        url: 'congtt-admin-phong-ban'
      },
        {Name: 'Quản trị chính sách', url: 'congtt-admin-chinh-sach'}, {
          Name: 'Quản trị gói cước',
          url: 'congtt-admin-goi-cuoc'
        },
        {
          Name: 'Quản trị quy trình quy định',
          url: 'congtt-admin-quy-trinh-quy-dinh'
        }, {Name: 'Quản trị chương trình khuyến mại', url: 'congtt-admin-chuong-trinh-khuyen-mai'},
        {Name: 'Quản trị hướng dẫn sử dụng', url: 'congtt-admin-huong-dan-su-dung'}, {
          Name: 'Quản trị Q&A',
          url: 'congtt-admin-q-a'
        },
        {Name: 'Quản trị hòm thư', url: 'congtt-admin-feedback'}, {
          Name: 'Quản trị SMS',
          url: 'congtt-admin-sms'
        }, {Name: 'Cấu hình email nhận phản hồi', url: 'congtt-admin-email'}];
    },

    onMoveTopic(item) {
      router.push({
        name: item.url
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-knowledge-base.scss";
</style>
<style lang="css">
.admin-menu .card-body {
  padding: 10px 0 !important;
}

.use-new .vgt-responsive {
  height: calc(100vh - 390px);
  background-color: #fff;
}

table.vgt-table td {
  min-width: 100px;
}
</style>
